import PDPTechSpecsFeature, {
  type PDPTechSpecsFeatureData,
} from './PDPTechSpecsFeature';

export interface PDPTechSpecsFeature extends PDPTechSpecsFeatureData {
  readonly id: string;
}

interface PDPTechSpecsFeaturesProps {
  readonly features: PDPTechSpecsFeature[];
}

const PDPTechSpecsFeatures = ({ features }: PDPTechSpecsFeaturesProps) => (
  <div className="grid grid-cols-1 gap-y-10 lg:grid-cols-2 lg:gap-x-6 lg:gap-y-16">
    {features.map(({ id, ...feature }) => (
      <div key={id}>
        <PDPTechSpecsFeature {...feature} />
      </div>
    ))}
  </div>
);

export default PDPTechSpecsFeatures;
